<div class="provider-details">
  <div class="modules">
    <section class="detail-tabs-header" data-test="tabs-header">
      @for (module of moduleNames; track module) {
        <button
          [ngClass]="{'selected-section' : module === lastSelectedSection}"
          class="detail-section-link"
          (click)="scrollToSection(module)"
          [attr.data-test]="'section-link-' + module"
        >
          {{ module }}
        </button>
      }
    </section>
  
    @if (showBioSection()) {
      <section
        id="about-section"
        class="about info-module"
        data-test="about-section"
      >
        <a id="about-link" [href]="currentRoute + '#about'">
          <h3>Meet {{ providerShareableProfile().display_first_name }}</h3>
        </a>
        <p data-test="provider-bio">{{ providerBio }}</p>

        @if (showTestimonial) {
          <div class="clients-are-saying" data-test="clients-are-saying">
            <div class="icon-header">
              <iris-icon
                name="quote"
                [size]="iconSizes.LG"
                colorToken="$color-dec-indigo-100"
              />
              <h4>Clients are saying...</h4>
            </div>
            <div class="testimonial">
              <span class="testimonial-feedback">{{ latestTestimonialFeedback }}</span>
              <span class="testimonial-source">{{ latestTestimonialSource }}</span>
            </div>
          </div>
        }
      </section>
    }

    @if (showSpecialtiesSection()) {
      <section 
        class="specialties info-module"
        id="specialties-section"
        data-test="specialties-section"
      >
        <section data-test="specialties">
          <hr />
          <a id="specialties-link" [href]="currentRoute + '#specialties'" class="section-header">
            <iris-icon
              name="stars"
              [size]="iconSizes.MD"
              colorToken="$color-dec-kelly-100"
            />
            <h3>{{ headerNames.SPECIALIZES_IN }}</h3>
          </a>
          <div 
            class="top-specialties-pills" 
            data-test="top-specialties-pills"
          >
            @for (speciality of topSpecialties(); track speciality.id) {
              <pill
                icon="star"
                [displayText]="speciality.name"
              />
            }
          </div>
          <div class="parallel-list-container">
            <div class="single-column-list">
              @if (allOtherSortedSpecialties.length) {
                <h4>
                  General expertise in
                </h4>
              }
              <ul data-test="specialties-section-list">
                @for (specialty of allOtherSortedSpecialties; track specialty) {
                  <li>
                    {{ specialty }}
                  </li>
                }
              </ul>
            </div>
            @if (treatmentApproaches.length) {
              <div class="single-column-list">
                <h4>Treatment approaches</h4>
                <ul>
                  @for (approach of treatmentApproaches; track approach) {
                    <li>{{ approach }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        </section>
      </section>
    }

    @if (showWorksWithSection()) {
      <section
        class="info-module"
        id="works-with-section"
        data-test="works-with-section"
      >
      <hr />
        <a id="works-with-link" [href]="currentRoute + '#workswith'" class="section-header">
          <iris-icon
            name="groups"
            [usage]="iconUsageTypes.DECORATIVE"
            [size]="iconSizes.LG"
            colorToken="$color-dec-kelly-100"></iris-icon>
          <h3> 
            {{ moduleNames[moduleNames.length - 2] }}
          </h3>
        </a>
        <div class="parallel-list-container">
          <div class="single-column-list">
            <h4>Types of services</h4>
            <ul>
              @for (serviceOffered of providerShareableProfile().services_offered; track serviceOffered.id) {
                <li>{{ serviceOffered?.name }}</li>
              }
            </ul>
          </div>
          @if (agesSupported.length > 0) {
            <div class="single-column-list">
              <h4>Ages</h4>
              <ul>
                @for (age of agesSupported; track age) {
                  <li>{{ age }}</li>
                }
              </ul>
            </div>
          }
        </div>

        <div class="parallel-list-container">
          @if (communitiesSupported().length > 0) {
            <div class="single-column-list">
              <h4>Communities supported</h4>
              <ul>
                @for (community of communitiesSupported(); track community) {
                  <li>{{ community }}</li>
                }
              </ul>
            </div>
          }
          <div class="single-column-list">
            <h4>Languages</h4>
            <ul>
              @for (language of providerShareableProfile().languages; track language.id) {
                <li>{{ language?.name }}</li>
              }
            </ul>
          </div>
        </div>
      </section>
    }

    @if (showInsuranceLicensuresSection()) {
      <section
        id="insurance-and-licensure-section"
        class="info-module insurance-and-licensure"
        data-test="insurance-and-licensure-section"
      >
        <hr />
        <a id="insurance-and-licensure-link" [href]="currentRoute + '#insurance-and-licensure'" class="section-header">
          <iris-icon
            name="verified_user"
            [size]="iconSizes.MD"
            colorToken="$color-dec-kelly-100"
          />
          <h3>{{ moduleNames[moduleNames.length - 1] }}</h3>
        </a>
        
        @if (providerNetworkCompaniesGroupedByInsuranceName.length > 0) {
          <h4>Insurance accepted</h4>
          @for (insuranceGroup of providerNetworkCompaniesGroupedByInsuranceName; track insuranceGroup[0].insurance_id) {
            <div
              class="insurance-list"
              data-test="insurances-section-list"
            >
              <span class="insurance-group-name"> {{ insuranceGroup[0].insurance_name }} </span>
              @if (insuranceGroup.length > 1) {
                <ul>
                  @for (pnc of insuranceGroup; track pnc.id) {
                    <li>
                      {{ pnc.name }}
                    </li>
                  }
                </ul>
              }
            </div>
          }
        }

        @if (licensures.length > 0) {
          <h4>Licensure</h4>
          <ul data-test="licensure-section-list">
            @for (licensure of licensures; track licensure) {
              <li>
                {{ licensure }}
              </li>
            }
          </ul>
        }
        
        @if (stateLicenses.length > 0) {
          <h4>Licensed in</h4>
          <ul data-test="licensed-in-list">
            @for (stateLicense of stateLicenses; track stateLicense) {
              <li>
                {{ stateLicense }}
              </li>
            }
          </ul>
        }
      </section>
    }
  </div>
</div>